module.exports = __webpack_public_path__ + "img/lancome_trash.63aea8b9.svg";